import axios from 'axios'
import md5 from 'js-md5'

// let baseURL = 'https://api-v2-vecdn.n2yun.net/'
// let baseURL = 'http://192.168.31.81:4000/'
let baseURL = 'https://api-v2.n2yun.net/'
// let baseURL = 'https://api-v2-r.n2yun.net:35534/'

if (process.env.NODE_ENV === 'production') {
  baseURL = 'https://api-v2.n2yun.net/'
}

localStorage.setItem('local_time', 0)

async function startGetTime() {
  let url = 'https://j.n2yun.com.cn/api/server/_stm'
  let res = await axios.get(url)
  let Time = parseInt(res.data.server_time)
  let localTime = Date.now()

  localStorage.setItem('local_time', Time - localTime)
}

startGetTime()

function getTime() {
  var Time = localStorage.getItem('local_time')
  var localTime = Date.now()

  if (Time >= -10000) {
    Time = 0
  }

  var adjustedTime = localTime + (Time ? parseInt(Time) : 0)

  return parseInt(adjustedTime) - parseInt(randomNum(100, 999))
  // return parseInt(adjustedTime)
}

const instance = axios.create({
  baseURL: baseURL,
  timeout: 8000,
  headers: {
    'Content-Type': 'application/json'
  }
})

const Token = 'IqBfMawdecJEib54EWZcud'

function getCookie(name) {
  const cookies = document.cookie.split(';');
  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(`${name}=`)) {
      return cookie.substring(name.length + 1);
    }
  }
  return null;
}

instance.interceptors.request.use(
  config => {
    if (config.method === 'get') {
      let relUrl = config.url
      const ctime = getTime()

      if (relUrl.indexOf("?") !== -1) {
        relUrl = relUrl.split("?")[0]
      }

      const sign = md5(relUrl + ctime + Token)

      if (config.params) {
        config.params.token = getToken()
        config.params.sign = sign
        config.params.signctime = ctime
      } else {
        config.params = {
          token: getToken(),
          sign: sign,
          signctime: ctime
        }
      }
    } else {
      let relUrl = config.url
      const ctime = getTime()

      if (relUrl.indexOf("?") !== -1) {
        relUrl = relUrl.split("?")[0]
      }


      if (config.data) {
        config.data.token = getToken()
      } else {
        config.data = {
          token: getToken()
        }
      }

      let config_data = JSON.stringify(config.data)
      const sign = md5(relUrl + config_data + ctime + Token)

      if (config.params) {
        config.params.sign = sign
        config.params.signctime = ctime
      } else {
        config.params = {
          sign: sign,
          signctime: ctime
        }
      }
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

//  获取本地的token
function getToken() {
  return getCookie('n2yunToken')
}




//生成从minNum到maxNum的随机数
function randomNum(minNum, maxNum) {
  switch (arguments.length) {
    case 1:
      return parseInt(Math.random() * minNum + 1, 10);
      break;
    case 2:
      return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
      break;
    default:
      return 0;
      break;
  }
}





// // ========== 请求去重适配器 ==========
// function generateRequestKey(config) {
//   const { method, url, params, data } = config;
//   // 深拷贝并清理认证字段
//   const cleanParams = { ...params };
//   const cleanData = { ...data };
//   delete cleanParams.token;
//   delete cleanParams.sign;
//   delete cleanParams.signctime;
//   delete cleanData.token;   // POST 请求 token 可能在 data 中
//   // 可选：对对象字段排序，避免参数顺序影响键值

//   const sortObject = (obj) => {
//     if (!obj || typeof obj !== 'object') return obj;
//     return Object.keys(obj).sort().reduce((acc, key) => {
//       acc[key] = obj[key];
//       return acc;
//     }, {});
//   };
//   const keyObj = {
//     method,
//     url,
//     params: sortObject(cleanParams),
//     data: sortObject(cleanData),
//   };
//   return JSON.stringify(keyObj);
// }

// const pendingRequests = new Map();
// const defaultAdapter = instance.defaults.adapter || axios.defaults.adapter;

// instance.defaults.adapter = function dedupAdapter(config) {
//   const key = generateRequestKey(config);
//   if (pendingRequests.has(key)) {
//     return pendingRequests.get(key);
//   }
//   const promise = defaultAdapter(config)
//     .then(response => {
//       pendingRequests.delete(key);
//       return response;
//     })
//     .catch(error => {
//       pendingRequests.delete(key);
//       return Promise.reject(error);
//     });
//   pendingRequests.set(key, promise);
//   return promise;
// };



export default instance